import { createSlice } from '@reduxjs/toolkit';

export const authorSlice = createSlice({
    name: "author",
    initialState: {active:false}
    ,
    reducers: {
        set: state => {
            state.active=true;
        },
        unset: state =>{
            state.active=false;
        }
    }
})

export const authorActions = authorSlice.actions;

export default authorSlice.reducer;